<template>
  <div class="col-12 col-md-3 item__block">
    <div class="item__title">{{ field.title }}</div>
    <div :class="field.badge ? 'badge bg-' + field.badge : ''">
      {{ isDate(field.data) ? formatDate(field.data) : field.data }}
    </div>
    <div
      v-if="field.baselineTitle"
      v-tooltip="{ hide: !field.baselineTooltip, title: field.baselineTooltip }"
      class="item__baseline"
    >
      {{ field.baselineTitle }}
    </div>
  </div>
</template>

<script>
import { dateFormatter } from "@/services/utilities/date-formatter";

export default {
  name: "RegistrationQuoteCellBlockComponent",
  components: {},
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    isDate(value) {
      return dateFormatter.isDate(value, this.locale);
    },
    formatDate(date) {
      return dateFormatter.format(date, "short");
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &__title {
    font-weight: 600;
  }

  &__block {
    margin-bottom: 20px;
  }

  &__baseline {
    color: $light-grey;
    font-style: italic;
  }
}
</style>
